<template>
  <div class="surverys-tab-survey-card card" :class="{ hoverable: !disabled }" :ref="dataSurvey.key"
    :data-step="dataSurvey.step">
    <div class="card-content">
      <div class="card-image waves-effect" @click="$_goTo()">
        <img @click="$_goTo()" :src="dataSurvey.thumbnail" alt="" :style="{
          filter: disabled ? 'grayscale(1)' : ''
        }" />
      </div>
      <div class="card-title center" @click="$_goTo()">
        {{ dataSurvey.title }}
      </div>
    </div>
    <!--  -->
    <div class="progress-wrapper">
      <div class="progress-pusher">
        <div class="description center" v-if="dataSurvey.key === 'water_hazard'">
          {{ progressBar }}
        </div>
        <div class="description center" v-else>
          {{ surveyStatus ? surveyStatus : progressBar }}
        </div>
        <!--  -->
        <div class="c-progress-bar-wrapper" v-if="dataSurvey.key === 'wind_hazard'">
          <div class="c-progress-percent" v-if="surveyStatus">
            {{ surveyStatus }}
          </div>
          <div class="c-progress-percent" v-else>
            {{ windHazardProgressX ? `${windHazardProgressX}%` : "Not Yet Started" }}
          </div>
          <div class="c-progress-bar">
            <div class="c-progress" :style="{ width: `${windHazardProgressX}%` }"></div>
          </div>
        </div>
        <!--  -->
        <div class="c-progress-bar-wrapper" v-else-if="dataSurvey.key === 'flood_hazard'">
          <div class="c-progress-percent" v-if="surveyStatus">
            {{ surveyStatus }}
          </div>
          <div class="c-progress-percent" v-else>
            {{ floodHazardProgressX ? `${floodHazardProgressX}%` : "Not Yet Started" }}
          </div>
          <div class="c-progress-bar">
            <div class="c-progress" :style="{ width: `${floodHazardProgressX}%` }"></div>
          </div>
        </div>
        <!--  -->
        <div class="c-progress-bar-wrapper" v-else-if="dataSurvey.key === 'assessment_summary'">
          <div class="c-progress-percent">
            {{ assessmentProgressX ? `${assessmentProgressX}%` : "Not Yet Started" }}
          </div>
          <div class="c-progress-bar">
            <div class="c-progress" :style="{ width: `${assessmentProgressX}%` }"></div>
          </div>
        </div>
        <!--  -->
        <div class="c-progress-bar-wrapper" v-else-if="dataSurvey.key === 'water_hazard'">
          <div class="c-progress-percent">
            {{ waterHazardProgressX ? `${waterHazardProgressX}%` : "Not Yet Started" }}
          </div>
          <div class="c-progress-bar">
            <div class="c-progress" :style="{ width: `${waterHazardProgressX}%` }"></div>
          </div>
        </div>
        <!--  -->
        <!--  -->
        <div class="c-progress-bar-wrapper" v-else-if="dataSurvey.key === 'home_profile'">
          <div class="c-progress-percent">
            {{ homeProfileProgressX ? `${homeProfileProgressX}%` : "Not Yet Started" }}
          </div>
          <div class="c-progress-bar">
            <div class="c-progress" :style="{ width: `${homeProfileProgressX}%` }"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="action-wrapper">
      <div class="card-action">
        <button v-tipped data-tooltip="Edit" class="btn-flat btn-floating waves-effect" :class="{ disabled: disabled }"
          :disabled="disabled || shouldFetch" @click="$_goTo()">
          <i class="material-icons-outlined indigo-text text-accent-4">edit</i>
        </button>

        <button v-tipped data-tooltip="Clear Data" @click="$_deleteCurrentSurvey(dataSurvey)"
          class="btn-flat btn-floating c-btn btn-delete waves-effect" :disabled="disabled || shouldFetch"
          :class="{ disabled: disabled }">
          <i class="material-icons-outlined grey-text text-darken-3">delete</i>
        </button>
        <button v-tipped data-tooltip="Resume" class="btn-flat btn-floating c-btn btn-continue waves-effect"
          :disabled="disabled || shouldFetch" @click="$_goToContinue()" :class="{ disabled: disabled }">
          <i class="material-icons-outlined grey-text text-darken-3">play_arrow</i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, } from "vuex";
import { deleteSurvey, getSurvey, updateSurvey } from "@/api/survey.api";
import { schema as floodSchema } from "@/schemas/floodHazard";
import { schema as windSchema } from "@/schemas/windHazard";

const isElementInView = (elChild, elParent) => {
  const elChildRect = elChild.getBoundingClientRect();
  const isInView = elChildRect.left >= 0 && elChildRect.right <= elParent.clientWidth;

  return isInView;
};

export default {
  name: "SurveysTabSurveyCard",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    dataSurvey: {
      type: Object,
      default: () => ({}),
    },
    dataPerformViewCheck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      parentEl: null,
      surveyStatus: "",
    };
  },
  beforeDestroy() {
    this.$store.commit("CLEAR_DIALOG");
  },
  mounted() {
    this.parentEl = document.getElementById("home-survey-tabs");
    //this.$_isElementInView();
    this.$_getSurvey();
  },
  watch: {
    dataPerformViewCheck() {
      this.$_isElementInView();
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.User.user,
      windHazard: (state) => state.Surveys.windHazard,
      floodHazard: (state) => state.Surveys.floodHazard,
      waterHazard: (state) => state.Surveys.waterHazard,
      shouldFetch: (state) => state.Surveys.shouldFetch,
    }),
    userRole: {
      get() {
        return 'subscriber'
        return this.user && this.user.roles.length > 0
          ? this.user.roles[0]
          : false
      },
    },
    homeProfileProgressX: {
      get() {
        const typeValCheck = (x) => {
          let condition_1 = (x && Array.isArray(x) && x.length > 0) || (x && !Array.isArray(x) & (x !== "") && x !== null) ? true : false;
          let condition_2 = !condition_1 && x !== "" && x !== null ? true : false;
          return condition_1;
        };
        if (!this.user?.home_profile) return 0;
        let hp = this.user.home_profile !== "" && this.user.home_profile ? JSON.parse(this.user.home_profile) : false;
        return hp ? ((Object.values(hp).filter((x) => typeValCheck(x)).length / Object.values(hp).length) * 100).toFixed(0) : 0;
      },
    },
    windHazardProgressX() {
      if (this.windHazard && this.windHazard.survey !== "") {
        // Get all complete_field keys from schema
        const completeFieldKeyArray = Object.keys(windSchema).filter((key) => windSchema[key].fieldType === "complete_field");

        const currentLen = completeFieldKeyArray.filter((key) => this.windHazard.survey[key]).length;

        const answerLen = Object.values(this.windHazard.survey).filter((item) => {
          if (typeof item === "object") {
            if (item.length > 0) {
              return item;
            }
          } else {
            return item;
          }
        }).length;

        if (answerLen <= 0 && currentLen <= 0) {
          this.surveyStatus = "Not Yet Started";
          return 0;
        }

        if (answerLen > 0 && currentLen <= 0) {
          this.surveyStatus = "Incomplete";
          return 0;
        }

        this.surveyStatus = "";

        return Math.round((currentLen / completeFieldKeyArray.length) * 100);
      }
      return 0;
    },
    floodHazardProgressX() {
      if (this.floodHazard) {
        // Get all complete_field keys from schema
        const completeFieldKeyArray = Object.keys(floodSchema).filter((key) => floodSchema[key].fieldType === "complete_field");

        const currentLen = completeFieldKeyArray.filter((key) => this.floodHazard.survey[key]).length;

        const answerLen = Object.values(this.floodHazard.survey).filter((item) => {
          if (typeof item === "object") {
            if (item.length > 0) {
              return item;
            }
          } else {
            return item;
          }
        }).length;

        if (answerLen <= 0 && currentLen <= 0) {
          this.surveyStatus = "Not Yet Started";
          return 0;
        }

        if (answerLen > 0 && currentLen <= 0) {
          this.surveyStatus = "Incomplete";
          return 0;
        }

        this.surveyStatus = "";

        return Math.round((currentLen / completeFieldKeyArray.length) * 100);
      }

      return 0;
    },
    assessmentProgressX: {
      get() {
        if (!this.floodHazard || !this.windHazard || !this.waterHazard) return 0;
        const allArr = [{ ...this.floodHazard }, { ...this.windHazard }, { ...this.waterHazard }];
        const k = allArr.map((x) => x.assessment).filter((y) => y.priority_rating && y.key_vuln && y.key_vuln.length).length * (100 / allArr.length).toFixed(0);
        return k > 97 ? 100 : k;
      },
    },
    waterHazardProgressX() {
      if (this.waterHazard) {
        const len = 2;

        const currentLen = Object.keys(this.waterHazard.survey).filter((key) => {
          if (key === "water_resiliency_complete") {
            return this.waterHazard.survey[key]; //this.waterHazard.survey[key].length > 0 ? true : false;
          } else if (this.waterHazard.isNonStandard && key === "manualEssential") {
            return this.waterHazard.survey[key].subTotal && parseFloat(this.waterHazard.survey[key].subTotal) > 1;
          } else if (!this.waterHazard.isNonStandard && key === "essential") {
            return this.waterHazard.survey[key].subTotal && parseFloat(this.waterHazard.survey[key].subTotal) > 1;
          } else {
            /*     else if (this.waterHazard.totalWaterStorage && this.waterHazard.totalWaterStorage !== '' ) {
             return  true
            } */
            return false;
          }
        }).length;
        return Math.round((currentLen / len) * 100);
      }

      return 0;
    },
    progressBar: {
      get() {
        return this.dataSurvey.key === "wind_hazard" && this.windHazardProgressX
          ? `${this.windHazardProgressX}% Completed`
          : this.dataSurvey.key === "assessment_summary" && this.assessmentProgressX
            ? `${this.assessmentProgressX}% Completed`
            : this.dataSurvey.key === "flood_hazard" && this.floodHazardProgressX
              ? `${this.floodHazardProgressX}% Completed`
              : this.dataSurvey.key === "home_profile" && this.homeProfileProgressX
                ? `${this.homeProfileProgressX}% Completed`
                : this.dataSurvey.key === "water_hazard" && this.waterHazardProgressX
                  ? `${this.waterHazardProgressX}% Completed`
                  : "Not Yet Started";
      },
    },
  },
  methods: {
    ...mapActions({
      updateWindSurvey: "Surveys/UPDATE_WIND_HAZARD",
      setWindSurveyStarted: "Surveys/SET_WIND_HAZARD_STARTED",
      updateWaterSurvey: "Surveys/UPDATE_WATER_HAZARD",
      setWaterSurveyStarted: "Surveys/SET_WATER_HAZARD_STARTED",
      updateFloodSurvey: "Surveys/UPDATE_FLOOD_HAZARD",
      setFloodSurveyStarted: "Surveys/SET_FLOOD_HAZARD_STARTED",
      setShowTour: "Surveys/SET_SHOW_SURVEY_TOUR",
    }),
    $_getSurvey() {
      if (this.shouldFetch) {
        getSurvey(this.user.id, this.dataSurvey.tag)
          .then((res) => {
            const data = res.data[0];
            // Store survey data
            if (data) {
              this.setShowTour(false);
              const survey = JSON.parse(data.acf.survey_data);
              survey.id = data.id;
              if (this.dataSurvey.key === "wind_hazard") {
                console.log(res);
                this.updateWindSurvey(survey);
                this.setWindSurveyStarted(true);
              } else if (this.dataSurvey.key === "flood_hazard") {
                this.updateFloodSurvey(survey);
                this.setFloodSurveyStarted(true);
              } else {
                this.updateWaterSurvey(survey);
                this.setWaterSurveyStarted(true);
              }
            }
            this.$emit("updateFetch", this.dataSurvey.tag);
          })
          .catch((err) => {
            this.$emit("updateFetch", this.dataSurvey.tag);
          });
      }
    },
    $_isElementInView() {
      const inView = isElementInView(this.$refs[this.dataSurvey.key], this.parentEl);

      this.$emit("updateElView", {
        key: this.dataSurvey.key,
        isInView: inView,
      });
    },
    $_deleteCurrentSurvey(e) {
      // if (this.userRole === 'subscriber') return
      let data = {
        title: `Clear ${e.title} data`,
        message: `Area you sure you want to clear all data associated with ${e.title}`,
        //hasImage: '/img/banner-image@2x.cd301ba7.png',
        buttons: [
          {
            id: 0,
            value: "DISMISS",
            action: () => {
              this.$store.commit("CLEAR_DIALOG");
            },
            close: true,
          },

          {
            id: 1,
            value: "CLEAR DATA",
            action: () => {
              //    console.log(e)
              if (e.delete !== "HomeProfile") {
                this.$store.commit("Surveys/DELETE_SURVEY_DATA", {
                  item: e.delete === "WindHazard" ? "windHazard" : e.delete === "FloodHazard" ? "floodHazard" : e.delete === "WaterHazard" ? "waterHazard" : "",
                });
              } else {
                this.$store.commit("User/UPDATE_USER", { home_profile: "" });
              }
              this.$store.commit("CLEAR_DIALOG");
            },
            close: true,
          },
        ],
        dataType: "",
      };
      /* e.route !== "HomeProfile"
        ?  */ this.$store.commit("TRIGGER_DIALOG", { data: data });
      //: this.$store.commit("User/UPDATE_USER", { home_profile: "" });
    },
    $_goTo() {
      if (this.disabled) return;
      this.$router.push({ name: this.dataSurvey.route });
    },
    $_goToContinue() {
      try {
        let oldHistory = localStorage.getItem("stepHistory");

        if (oldHistory) {
          let newBlock = JSON.parse(oldHistory);
          if (newBlock[this.dataSurvey.route.toLowerCase()]) {
            this.$router.push({
              name: this.dataSurvey.route,
              query: {
                editing: true,
                section: newBlock[this.dataSurvey.route.toLowerCase()].step,
                step: newBlock[this.dataSurvey.route.toLowerCase()].step,
              },
            });
          } else this.$_goTo();
        } else {
          this.$_goTo();
        }
      } catch (error) {
        this.$_goTo();
        console.log(error);
        return error;
      }
    },
    $_saveDataToCould(id) {
      if (id) {
        if (id) {
          const payload = {
            fields: {
              survey_data: JSON.stringify(this.windHazard),
            },
          };
          updateSurvey(id, payload)
            .then((res) => { })
            .catch((err) => {
              // Better erorr handling
              console.log(err);
              if (err.response.data) {
                console.log(err.response.data);
              }
            });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.surverys-tab-survey-card {
  /*   flex-shrink: 0;
  border-radius: 5px;
  width: 200px;
  padding: 1rem;
  margin-right: 25px; */
  /*
  .image-wrapper {
    width: 100%;
    height: 140px;
    img {
      width: 100%;
      height: 100%;
    }
  } */

  /*   .title {
    text-transform: uppercase;
    color: #545454;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  } */
  &.card {
    height: calc(100% - 1.5rem);
    border-radius: 10px;

    /* 	overflow: hidden; */
    .card-image {
      height: 140px;

      @media screen and (min-width: 1024px) {
        height: 140px;
      }

      width: 100%;
      text-align: center;

      img {
        height: 100%;
        width: auto;
        display: inline-block;
      }
    }

    .card-content {
      padding: 16px 16px 0;

      .card-title {
        font-size: 15.5px;
        line-height: 20px;
        font-weight: 600;
        margin-bottom: 0px;
        cursor: pointer;
        text-transform: uppercase;
      }
    }

    .action-wrapper {
      height: 56px;
      width: 100%;

      .card-action {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }

    .card-action {
      padding: 0px 16px 16px 16px;
      border-radius: 0px 0px 5px 5px;
      display: flex;
      justify-content: space-between;

      button {
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .description {
    font-size: 12px;
  }

  .c-progress-bar-wrapper {
    margin-top: 0px;

    .c-progress-percent {
      font-size: 9px;
      color: #9c9c9c;
    }

    .c-progress-bar {
      position: relative;
      border-radius: 5px;
      width: 100%;
      height: 9px;
      background: #e4e4e4;
      overflow: hidden;
    }

    .c-progress {
      background: #5374f8;
      height: 100%;
    }
  }

  .progress-wrapper {
    padding: 0 16px 16px;
    height: 64px;

    .progress-pusher {
      position: absolute;
      width: calc(100% - 32px);
      bottom: 72px;
    }
  }
}


.btn-flat[disabled] {
  background-color: #DFDFDF !important;
}
</style>


